<template>
  <div class="menu-btn">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right" @submit.native.prevent>
      <div style="max-width: 222px;">
        <el-form-item label-width="42px" label="状态：">
          <el-checkbox-group class="zwx-checkbox-group" v-model="mainForm.ifEnables">
            <el-checkbox class="zwx-checkbox" :label="true">启用</el-checkbox>
            <el-checkbox class="zwx-checkbox" :label="false">停用</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider" />
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
      <el-button class="zwx-button zwx-button-icontext-28" icon="el-icon-plus" @click="add()" v-if="$validate.checkbtns(btns[0])">添加</el-button>
    </div>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" style="width: 100%;" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="btnName" label="按钮名称" :width="$system.calWidth(dataList, 'btnName', '按钮名称')" header-align="left" align="left"></el-table-column>
      <el-table-column prop="btnCode" label="按钮编码" :width="$system.calWidth(dataList, 'btnCode', '按钮编码')" header-align="center" align="center"></el-table-column>
      <el-table-column fixed="right" label="操作" :min-width="$system.calMinWidth({ wordNum: 6, arrowNum: 1, btnNum: 4 })" header-align="left" align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right" @click="edit(scope.row)" v-if="$validate.checkbtns(btns[0])">编辑</el-button>
          <el-button class="zwx-button zwx-button-text-26" :style="scope.row.ifEnable ? 'color: #e72b00 !important;' : ''" type="text" @click="$system.msgbox(scope.row, '提示', scope.row.ifEnable ? '确定要停用吗？' : '确定要启用吗？', '确定', '取消', enable)" v-if="$validate.checkbtns(btns[0])">{{ scope.row.ifEnable ? '停用' : '启用' }}</el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger" @click="$system.msgbox(scope.row, '提示', '确定要删除吗？', '确定', '取消', deletion)" v-if="!scope.row.ifEnable && $validate.checkbtns(btns[0])">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'MenuBtn',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      btns: ['e96660be58dfbf6c'],
      rid: this.$route.params.rid,
      menuTitle: this.$route.params.menuTitle,
      mainForm: {
        ifEnables: [],
      },
      dataList: [],
    }
  },
  created() {
    this.$emit('breadcrumb', this.menuTitle, false)
  },
  mounted() {
    this.search()
  },
  activated() {
    if (this.$route.params.fresh) this.search()
  },
  computed: {},
  methods: {
    search() {
      this.$emit('loading', true)
      let data = {
        menuId: this.rid,
        ifEnable: this.mainForm.ifEnables.length === 1 ? this.mainForm.ifEnables[0] : null,
      }
      this.$system.get(this.api + '/systematic/getBtnList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.btnList
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    enable(row) {
      this.$emit('loading', true)
      let data = { rid: row.rid, ifEnable: !row.ifEnable }
      this.$system.post(this.api + '/systematic/modifyBtnState-1', data, true, true, this.enableSuccess, this.error)
    },
    enableSuccess(data) {
      if (data.type === '00') {
        this.search()
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    deletion(row) {
      this.$emit('loading', true)
      let data = { rid: row.rid }
      this.$system.post(this.api + '/systematic/deleteBtn-1', data, true, true, this.deletionSuccess, this.error)
    },
    deletionSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.search()
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    add() {
      this.$router.push({ name: 'MenuBtnEdit', params: { menuId: this.rid } })
    },
    edit(row) {
      this.$router.push({ name: 'MenuBtnEdit', params: { rid: row.rid } })
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
